<div class="container">
    <div class="row justify-content-center ">
        <div class="col-12 text-center title-text">
            <div class=" mb-5">
                <h2>Add New User</h2>
            </div>
        </div>


        <div class="col-lg-10">
            <form [formGroup]="userCreationForm" (ngSubmit)="createUser()" nzForm autocomplete="off">
                <!-- Fake Inputs to avoid AutoFill  -->
                <nz-form-item>
                    <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzFor="Company Name">Name</nz-form-label>
                    <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Please Enter Customer Name!">
                        <nz-input-group>
                            <input autocomplete="off" formControlName="userName" type="text" nz-input id="user_name"
                                placeholder=" Enter User name" required>
                        </nz-input-group>
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzFor="emailId">Email</nz-form-label>
                    <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Please Enter Valid Email Address!">
                        <nz-input-group>
                            <input autocomplete="off" formControlName="userEmail" type="email" nz-input
                                id="user_emailId" placeholder="Enter Email Address">
                        </nz-input-group>
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzFor="user_password">Password</nz-form-label>
                    <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Please Enter Password!">
                        <nz-input-group [nzSuffix]="suffixTemplate">
                            <input autocomplete="new-password" formControlName="password"
                                [type]="passwordVisible ? 'text' : 'password'" nz-input id="user_password"
                                placeholder="Enter Password" required>
                        </nz-input-group>
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzFor="mobile">Phone</nz-form-label>
                    <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Please Enter Phone Number!">
                        <nz-input-group>
                            <input required autocomplete="off" formControlName="userPhoneNumber" nz-input id="mobile"
                                placeholder="Enter Phone Number" type="text"
                                onkeypress="return event.charCode === 0 || /\d/.test(String.fromCharCode(event.charCode));"
                                pattern="[0-9]*" maxlength="10"
                                oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);">
                        </nz-input-group>
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzFor="attributeValue">Role</nz-form-label>
                    <nz-form-control [nzSm]="14" [nzXs]="24" nzErrorTip="Please Select User Role!">
                        <nz-input-group>
                            <nz-select autocomplete="off" [(ngModel)]="userRole" [ngModelOptions]="{standalone: true}"
                                (ngModelChange)="roleChange()" class="w-100" nzPlaceHolder="Select User Role" required>
                                <nz-option nzLabel="Admin" nzValue="Admin"></nz-option>
                                <nz-option nzLabel="Customer" nzValue="Customer"></nz-option>
                                <nz-option nzLabel="Supplier" nzValue="Supplier"></nz-option>
                            </nz-select>
                        </nz-input-group>
                    </nz-form-control>
                </nz-form-item>

                <!-- <nz-form-item>
                <nz-form-label [nzSm]="6" [nzXs]="24" nzRequired nzFor="attributeActive">Active</nz-form-label>
                <nz-form-control [nzSm]="14" [nzXs]="24">
                    <nz-input-group class="active_status">
                        <nz-switch formControlName="inActive" [nzCheckedChildren]="checkedTemplate"
                            [nzUnCheckedChildren]="unCheckedTemplate">
                        </nz-switch>
                        <ng-template #checkedTemplate><i nz-icon nzType="check"></i></ng-template>
                        <ng-template #unCheckedTemplate><i nz-icon nzType="close"></i></ng-template>
                    </nz-input-group>
                </nz-form-control>
            </nz-form-item> -->

                <div *ngIf="userRole != 'Admin'" class="add-list-div">
                    <nz-form-item>
                        <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="legal_entity">Legal Entity</nz-form-label>
                        <nz-form-control [nzSm]="14" [nzXs]="24">
                            <nz-input-group>
                                <nz-select autocomplete="off" [(ngModel)]="dbData" [ngModelOptions]="{standalone: true}"
                                    (ngModelChange)="getBpList()" class="w-100" nzPlaceHolder="Select Legal Entity">
                                    <nz-option *ngFor="let db of dbList" [nzLabel]="db.dbName" [nzValue]="db.dbCode">
                                    </nz-option>
                                </nz-select>
                            </nz-input-group>
                        </nz-form-control>
                    </nz-form-item>

                    <nz-form-item>
                        <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="list">Company List</nz-form-label>
                        <nz-form-control [nzSm]="14" [nzXs]="24">
                            <nz-input-group>
                                <nz-select autocomplete="off" nzShowSearch [(ngModel)]="bpData"
                                    [ngModelOptions]="{standalone: true}"
                                    (ngModelChange)="structureDBArray(bpData , bpList , 'bp')" class="w-100"
                                    nzPlaceHolder="Select List">
                                    <nz-option *ngFor="let bp of bpList" [nzLabel]="bp.bpName" [nzValue]="bp.bpCode">
                                    </nz-option>
                                </nz-select>
                            </nz-input-group>
                        </nz-form-control>
                    </nz-form-item>

                    <nz-form-item class="text-right ml-5">
                        <nz-form-control [nzSm]="20" [nzXs]="24">
                            <div class="db_access_section">
                                <button type="button" (click)="createList()" nzType="primary" class="add_list-button"
                                    nz-button>Add</button>

                                <div class="selected_tags mt-3">
                                    <nz-tag [nzColor]="'blue'" *ngFor="let list of listArray ; let i = index"
                                        nzMode="closeable" (nzOnClose)="clearList(i)">
                                        {{list.dbDetails.dbName + ' - ' + list.companyDetails.bpName}}
                                    </nz-tag>
                                </div>
                            </div>
                        </nz-form-control>
                    </nz-form-item>
                </div>

                <nz-form-item class="text-center ml-5">
                    <nz-form-control>
                        <a><button class="reset_button" nz-button type="reset" nzType="default">Reset</button></a>
                        <a><button nz-button nzType="primary">Create User</button></a>
                    </nz-form-control>
                </nz-form-item>

            </form>

        </div>
    </div>

    <ng-template #suffixTemplate>
        <i nz-icon [nzType]="passwordVisible ? 'eye' : 'eye-invisible'"
            (click)="passwordVisible = !passwordVisible"></i>
    </ng-template>

</div>



<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="line-scale-pulse-out-rapid"
    [fullScreen]="true">
    <!-- <p style="color: white"> Loading... </p> -->
</ngx-spinner>